import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useCallback } from "react";

import { WriteToPage } from "@/features/support/pages";

export const Route = createFileRoute("/_app/specialists/support/to/$userId")({
  component: WriteTo,
});

function WriteTo() {
  const { userId } = Route.useParams();
  const router = useRouter();
  const onThread = useCallback(
    (threadId: string) =>
      void router.navigate({
        to: "/specialists/support/$threadId",
        params: { threadId },
        replace: true,
      }),
    [router],
  );
  return <WriteToPage key={userId} userId={userId} onThread={onThread} />;
}
